"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgScriptStatus(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm12 8a4 4 0 1 0 4 4 4 4 0 0 0 -4-4zm-.675 6-1.825-1.705.7-.65 1.18 1.1 2.415-2.245.705.645zm-3.10363-5.24084h-6.01507c.36047-2.72394.82294-6.19379.96149-7.125.23721-1.59339 1.26471-1.63416 1.26471-1.63416h8.69488c-.98816.04077-1.10669 1.96094-1.10669 1.96094s-.34466 2.654-.66986 5.10449a4.9575 4.9575 0 0 0 -3.12946 1.69373zm4.59571-6.14582c.20227-2.14034.73669-1.99127.73669-1.99127a7.239 7.239 0 0 1 .44623 1.99127zm-5.79187 9.63666h-5.72162c-.93689 0-1.30359-2.61469-1.30359-2.61469h7.62006a4.94426 4.94426 0 0 0 -.62006 2.36469c0 .08563.02094.16541.02521.25z' })));
}
exports.default = SvgScriptStatus;
